"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.antibodies = void 0;
var antibodies = {
  "viewBox": "0 0 64 64",
  "children": [{
    "name":"path",
    "attribs":{
        "d":"M17.4 49.772A23.034 23.034 0 0032 55v-2a21.037 21.037 0 01-13.33-4.772zM33.911 52.914l.179 1.992a22.874 22.874 0 002.091-.286l-.361-1.967c-.632.117-1.274.204-1.909.261zM32.913 11.02l.086-1.998a24.232 24.232 0 00-2.088.004l.093 1.998c.633-.03 1.275-.032 1.909-.004zM37.137 9.576a23.692 23.692 0 00-2.056-.372l-.267 1.982c.627.084 1.259.198 1.878.339zM29.102 11.199l-.272-1.982c-.687.094-1.378.222-2.056.379l.453 1.948a21.079 21.079 0 011.875-.345z"
    }},
  {
    "name":"path",
    "attribs":{
        "d":"M32 1C14.907 1 1 14.907 1 32s13.907 31 31 31 31-13.907 31-31S49.093 1 32 1zm0 60C16.009 61 3 47.991 3 32S16.009 3 32 3s29 13.009 29 29-13.009 29-29 29z"
    }},
  {
    "name":"path",
    "attribs":{
        "d":"M53.293 37.293l-1 1-7 7 1.414 1.414 7-7 1-1zM28.707 37.293l-1.414 1.414 1 1 7 7 1.414-1.414-7-7z"
    }},
  {
    "name":"path",
    "attribs":{
        "d":"M51 36.171A3.175 3.175 0 0047.829 33c-.801 0-1.555.312-2.122.879L41 38.586l-4.707-4.707A2.978 2.978 0 0034.171 33 3.175 3.175 0 0031 36.171c0 .801.312 1.555.879 2.122l5.828 5.828a.996.996 0 01.293.708V50c0 1.654 1.346 3 3 3s3-1.346 3-3v-5.171c0-.267.104-.519.293-.708l5.828-5.828c.567-.566.879-1.32.879-2.122zm-2.293.708l-5.828 5.828A2.978 2.978 0 0042 44.829V50c0 .551-.449 1-1 1s-1-.449-1-1v-5.171c0-.801-.312-1.555-.879-2.122l-5.828-5.828a.996.996 0 01-.293-.708c0-.646.525-1.171 1.171-1.171.267 0 .519.104.708.293L41 41.414l6.121-6.121a.996.996 0 01.708-.293c.646 0 1.171.525 1.171 1.171a.996.996 0 01-.293.708zM24.707 38.707l-1.414-1.414-1 1-7 7 1.414 1.414 7-7zM37.293 18.707l7 7 1.414-1.414-7-7-1-1-1.414 1.414z"
    }},
  {
    "name":"path",
    "attribs":{
        "d":"M32 5C17.112 5 5 17.112 5 32s12.112 27 27 27 27-12.112 27-27S46.888 5 32 5zm16.121 16.707l-5.828-5.828a.996.996 0 01-.293-.708c0-.646.525-1.171 1.171-1.171.267 0 .519.104.708.293L50 20.414l2.582-2.582c.435.631.841 1.283 1.219 1.953l-1.922 1.922A2.978 2.978 0 0051 23.829V29c0 .551-.449 1-1 1s-1-.449-1-1v-5.171c0-.802-.312-1.556-.879-2.122zM12 44.829v2.154a24.928 24.928 0 01-4.223-8.792L11 41.414l6.121-6.121a.996.996 0 01.708-.293c.646 0 1.171.525 1.171 1.171a.996.996 0 01-.293.708l-5.828 5.828A2.978 2.978 0 0012 44.829zM32 57c-7.065 0-13.449-2.95-18-7.677v-4.494c0-.267.104-.519.293-.708l5.828-5.828c.567-.566.879-1.32.879-2.122A3.175 3.175 0 0017.829 33c-.801 0-1.555.312-2.122.879L11 38.586l-3.847-3.847A25.28 25.28 0 017 32C7 18.215 18.215 7 32 7c7.804 0 14.782 3.596 19.37 9.216L50 17.586l-4.707-4.707A2.978 2.978 0 0043.171 12 3.175 3.175 0 0040 15.171c0 .801.312 1.555.879 2.122l5.828 5.828a.996.996 0 01.293.708V29c0 1.654 1.346 3 3 3s3-1.346 3-3v-5.171c0-.267.104-.519.293-.708l1.46-1.46A24.842 24.842 0 0157 32c0 13.785-11.215 25-25 25z"
    }},
  {
    "name":"path",
    "attribs":{
        "d":"M27.707 30.121c.566.567 1.32.879 2.122.879A3.175 3.175 0 0033 27.829c0-.801-.312-1.555-.879-2.122l-5.828-5.828a.996.996 0 01-.293-.708V14c0-1.654-1.346-3-3-3s-3 1.346-3 3v5.171a.996.996 0 01-.293.708l-5.828 5.828A2.978 2.978 0 0013 27.829 3.175 3.175 0 0016.171 31c.801 0 1.555-.312 2.122-.879L23 25.414zm-10.828-1.414a.996.996 0 01-.708.293A1.172 1.172 0 0115 27.829c0-.267.104-.519.293-.708l5.828-5.828c.567-.566.879-1.32.879-2.122V14c0-.551.449-1 1-1s1 .449 1 1v5.171c0 .801.312 1.555.879 2.122l5.828 5.828a.996.996 0 01.293.708c0 .646-.525 1.171-1.171 1.171a.996.996 0 01-.708-.293L23 22.586z"
    }},
  {
    "name":"path",
    "attribs":{
        "d":"M17.293 17.293l-7 7-1 1 1.414 1.414 1-1 7-7zM28.707 17.293l-1.414 1.414 7 7 1 1 1.414-1.414-1-1z"
    }}],
  "attribs": {
    "fill": "none",
    "stroke": "currentColor",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }
};
exports.antibodies = antibodies;
